import { Section, Center } from '@styled/global';
import styled from 'vue-styled-components';
import { fontSize } from 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   border-left: 1px solid #007582;\n   padding: 0 0.4rem 0 0.4rem;\n\n   cursor: pointer;\n   list-style-type: none;\n   display: flex;\n   white-space: nowrap;\n\n   &:first-child {\n      border-left: none;\n   }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   font-family: inherit;\n   display: flex;\n   flex-direction: row;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 0;\n   margin: 5px 0 5px 0;\n   line-height: normal;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Navigation = styled("nav", {})(_templateObject());
var NavBar = styled("ul", {
  fontSize: {
    default: function _default() {
      return [0, 0, 1, 2];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject2(), fontSize);
var NavItem = styled("li", {})(_templateObject3());

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  render: function render() {
    var h = arguments[0];
    var links = this.copy.links.map(function (link) {
      return h(NavItem, [h("RouterLink", {
        "domProps": {
          "innerHTML": link.label
        },
        "attrs": {
          "to": link.url,
          "id": link.id
        }
      })]);
    });
    return h(Section, {
      "style": {
        borderBottom: "2px solid #fff"
      }
    }, [h(Center, [h(Navigation, [h(NavBar, [links])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
